import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import { DatePickerInput } from "rc-datepicker";
import { FormGroup } from "react-bootstrap";

const RmTicketsFilterForm = ({
  applyFilter,
  siteTypes = [],
  siteCompStatus = [],
  internalStatus = [],
  // assignedAreas=[],
  statusId,
  reportees = [],
  complaintFilter = false,
  defaultInternalStatusId = "",
  city = [],
  ticket_tags,
  localstorageKey = "applyFilter",
  hideL2ClientFilters = false,
}) => {
  const roleDefaultInternalStatus =
    complaintFilter && defaultInternalStatusId ? defaultInternalStatusId : "";

  const filterInputs = {
    site_no: "",
    client_name: "",
    site_type: "",
    status: statusId,
    assignee_ids: "",
    complain_id: "",
    internalStatus: roleDefaultInternalStatus,
    fd_ticket_id: "",
    fusion_ticket_id: "",
    fromDate: "",
    toDate: "",
    city_id: "",
    ticket_tags_id: '',
    cx_category: "",
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [isFocus2, setIsFous2] = useState(false);
  const [isFocus3, setIsFous3] = useState(false);

  const handleDateChange2 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      fromDate: dateString,
    });
  };
  const handleDateChange3 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      toDate: dateString,
    });
  };

  const handleDateHide2 = () => {
    if (!filterFieldsData.fromDate) {
      setIsFous2(true);
    }
  };
  const handleDateHide3 = () => {
    if (!filterFieldsData.toDate) {
      setIsFous3(true);
    }
  };

  useEffect(() => {
    if (statusId) {
      setFilterFieldsData((prev) => ({ ...prev, status: statusId }));
    }
  }, [statusId]);

  useEffect(() => {
    const saved = JSON.parse(
      localStorage.getItem(localstorageKey) &&
        localStorage.getItem(localstorageKey)
    );
    if (saved) {
      setFilterFieldsData({
        ...filterInputs,
        ...saved,
        status: saved.status ?? statusId,
        internalStatus:
          saved.internalStatus !== undefined && saved.internalStatus !== null
            ? saved.internalStatus
            : roleDefaultInternalStatus,
      });
      if (saved.fromDate) setIsFous2(true);
      if (saved.toDate) setIsFous3(true);
    } else if (roleDefaultInternalStatus) {
      setFilterFieldsData({ ...filterInputs, internalStatus: roleDefaultInternalStatus });
    }
  }, [localstorageKey, roleDefaultInternalStatus, statusId]);


  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        const payload = { ...filterFieldsData, status: statusId || filterFieldsData.status };
        setFilterFieldsData(payload);
        applyFilter(payload);
        localStorage.setItem(localstorageKey, JSON.stringify(payload));

      }}
    >
      <ConstantInput
        label={localization.siteNumber}
        value={filterFieldsData.site_no}
        regex={Regex.alphaNum.test(filterFieldsData.site_no)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_no: val })
        }
      />
      <ConstantInput
        label={localization.clientName}
        value={filterFieldsData.client_name}
        regex={Regex.text.test(filterFieldsData.client_name)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, client_name: val })
        }
      />
      <ConstantInput
        label={localization.fd_ticket_id}
        value={filterFieldsData.fd_ticket_id}
        regex={Regex.alphaNum.test(filterFieldsData.fd_ticket_id)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, fd_ticket_id: val })
        }
      />
      <ConstantInput
        label={localization.complainId}
        value={filterFieldsData.complain_id}
        regex={Regex.alphaNum.test(filterFieldsData.complain_id)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, complain_id: val })
        }
      />
      {/* cx_category is not wired to fetchComplainSupport — hidden for L2 client ticket list */}
      {complaintFilter === false ? (
        <ConstantInput
          label={localization.categoryDetails}
          value={filterFieldsData.cx_category}
          regex={Regex.text.test(filterFieldsData.cx_category)}
          type="text"
          handleChange={(val) =>
            setFilterFieldsData({ ...filterFieldsData, cx_category: val })
          }
        />
      ) : null}
      {complaintFilter === false ?
        <ConstantInput
          label={localization.fusion_ticket_id}
          value={filterFieldsData.fusion_ticket_id}
          regex={Regex.alphaNum.test(filterFieldsData.fusion_ticket_id)}
          type="text"
          handleChange={(val) =>
            setFilterFieldsData({ ...filterFieldsData, fusion_ticket_id: val })
          }
        />
        : null}
      {complaintFilter ?
        <DropDownInput
          disabled={internalStatus.length === 0}
          label={localization.status}
          data={internalStatus}
          getValueById={filterFieldsData.internalStatus || ""}
          getIdValue={(val) =>
            setFilterFieldsData({ ...filterFieldsData, internalStatus: val.id })
          }
        />
        // <DropDownInput
        //   disabled={siteCompStatus.length === 0}
        //   label={localization.status}
        //   data={siteCompStatus}
        //   getIdValue={(val) =>
        //     setFilterFieldsData({ ...filterFieldsData, status: val.id })
        //   }
        // />
        :
        <DropDownInput
          disabled={siteTypes.length === 0}
          label={localization.status}
          data={siteTypes}
          getValueById={filterFieldsData.status || ""}
          getIdValue={(val) =>
            setFilterFieldsData({ ...filterFieldsData, status: val.id })
          }
        />
      }

      {!hideL2ClientFilters && city.length !== 0 ?
        <DropDownInput
          disabled={city.length === 0}
          label={localization.geoCity}
          data={city}
          getValueById={filterFieldsData.city_id || ""}
          getIdValue={(val) =>
            setFilterFieldsData({ ...filterFieldsData, city_id: val.id })
          }
        />
        : ''}

      {!hideL2ClientFilters ? (
      <DropDownInput
        disabled={ticket_tags.length === 0}
        label={localization.ticketTags}
        data={ticket_tags}
        getValueById={filterFieldsData.ticket_tags_id || ""}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, ticket_tags_id: val.id })
        }
      />
      ) : null}
      <DropDownInput
        disabled={reportees.length === 0}
        label={localization.assignee}
        data={reportees}
        getValueById={filterFieldsData.assignee_ids || ""}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, assignee_ids: val.id })
        }
      />

      <fieldset>
        <h4>{localization.createdBetween}</h4>

        <FormGroup
          className={`date custom_date_picker ${isFocus2 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange2}
            value={filterFieldsData.fromDate}
            autoClose
            onShow={() => setIsFous2(true)}
            onHide={handleDateHide2}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
          // maxDate={new Date()}
          />
          <label>{localization.fromDate}</label>
        </FormGroup>

        <FormGroup
          className={`date custom_date_picker ${isFocus3 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange3}
            value={filterFieldsData.toDate}
            autoClose
            onShow={() => setIsFous3(true)}
            onHide={handleDateHide3}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
          // maxDate={new Date()}
          />

          <label>{localization.toDate}</label>
        </FormGroup>
      </fieldset>

      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            const cleared = {
              ...filterInputs,
              status: statusId,
              internalStatus: roleDefaultInternalStatus,
            };
            setFilterFieldsData(cleared);
            localStorage.setItem(localstorageKey, JSON.stringify(cleared));
            applyFilter(cleared);
            localStorage.setItem("statusFilter", JSON.stringify({}));
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default RmTicketsFilterForm;
